import React from 'react'
import PropTypes from 'prop-types'
import { formValues, reduxForm, propTypes as reduxFormPropTypes } from 'redux-form'
import BEMHelper from '@ynap/bem-helper'
import { Button } from '@ynap/button'
import { Tooltip } from '@ynap/notification'
import Field from '@ynap/field'
import { submit } from '@ynap/form-utils'
import validate from './validate'
import collateErrors from './collateErrors'

const bem = new BEMHelper('PromotionForm')

const propTypes = {
    ...reduxFormPropTypes,
    form: PropTypes.string.isRequired,
    code: PropTypes.string,
    onCheckActivePromo: PropTypes.func,
    isCSR: PropTypes.bool,
    config: PropTypes.object.isRequired,
    messages: PropTypes.shape({
        promotionForm: PropTypes.shape({
            code: PropTypes.func,
            apply: PropTypes.func,
            title: PropTypes.func,
            label: PropTypes.func,
            inputPlaceholder: PropTypes.func,
        }),
        paymentCodes: PropTypes.shape({
            checkActivePromos: PropTypes.func,
        }),
        errors: PropTypes.shape({
            unknown: PropTypes.func,
            required: PropTypes.func,
            invalid: PropTypes.func,
            limitExceeded: PropTypes.func,
        }),
    }).isRequired,
    invalid: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
    inline: PropTypes.bool,
}

const defaultProps = {
    submitting: false,
}

export function PromotionForm(props) {
    const {
        form,
        error,
        invalid,
        submitting,
        handleSubmit,
        messages,
        className,
        children,
        inline = true,
        isCSR,
        onCheckActivePromo,
        code,
        promotionsCheckerInfo,
        submitFailed,
        config,
    } = props

    const { enablePromotionCheckerFeature = false } = config?.head?.flags ?? {}

    const promotionInfo = promotionsCheckerInfo?.[code]
    const reasonMessages = Object.values(promotionInfo?.reasons ?? {}).join('. ')
    const showExtraPromotionInfo = isCSR && submitFailed && !promotionInfo?.valid && !!reasonMessages.length
    const showCheckActivePromos = isCSR && enablePromotionCheckerFeature

    return (
        <>
            <form id={form} className={bem(null, { inline, submitting }, className)} onSubmit={handleSubmit(submit)}>
                <Field
                    className={bem('code')}
                    name="code"
                    placeholder={messages.promotionForm.inputPlaceholder?.()}
                    label={!inline && messages.promotionForm.label()}
                />
                {showExtraPromotionInfo && <span className={bem('promotion-checker-info')}>{reasonMessages}</span>}
                {children}
                <Tooltip type="error" message={error} defaultOpen={!!error} key={error}>
                    <Button className={bem(inline ? 'submitInline' : 'submit', { invalid })} disabled={invalid || submitting}>
                        {messages.promotionForm.apply()}
                    </Button>
                </Tooltip>
            </form>
            {showCheckActivePromos && (
                <Button component="a" className={bem('check-active-promos')} onClick={onCheckActivePromo}>
                    {messages?.paymentCodes?.checkActivePromos?.()}
                </Button>
            )}
        </>
    )
}

PromotionForm.propTypes = propTypes
PromotionForm.defaultProps = defaultProps

const PromotionFormWithValues = formValues({ code: 'code' })(PromotionForm)

export default reduxForm({ form: 'promotion', validate, collateErrors })(PromotionFormWithValues)
